module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vregi1-942bf8ae238a3454a1f7140e304abd7d.jpg";